export default function ExpireToken() {
    return (
      <iframe
        src="/page/expiretoken.html"
        title="Expire Token"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
          background: "#FDF6EF"
        }}
      />
    );
  }
  